import { Auth } from "aws-amplify";

const forgotPassword = async (email: string) => {
  await Auth.forgotPassword(email);
};

export default forgotPassword;
